import React, { createContext, useState } from 'react';

export type IdElementContextType = {
    IdElement: number;
    setIdElement: React.Dispatch<React.SetStateAction<number>> | any;
};

export const IdElementContext = createContext<IdElementContextType>({
    IdElement: 0,
    setIdElement: undefined,
});

export const IdElementProvider = ({ children }) => {
    const [IdElement, setIdElement] = useState<number>(1);

    return (
        <IdElementContext.Provider
            value={{
                IdElement,
                setIdElement,
            }}>
            {children}
        </IdElementContext.Provider>
    );
};

export default IdElementContext;
